import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, TextField, DialogActions, Button, Switch, FormControlLabel, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.css';

export default function AddLabelScaleDialog({ handleClose, handleSuccess, selectedLabelScale }) {
  const { t: tCommon } = useTranslation('common');
  const [data, setData] = useState({
    macId: selectedLabelScale?.macId || '',
    billPrefix: selectedLabelScale?.billPrefix || '',
    connectedTo: selectedLabelScale?.connectedTo || '',
    machineName: selectedLabelScale?.machineName || '',
    connectedPort: selectedLabelScale?.connectedPort || 0,
    machineNumber: selectedLabelScale?.machineNumber || 0,
    isSupportSales: selectedLabelScale?.isSupportSales || false,
    isSupportUnicode: selectedLabelScale?.isSupportUnicode || false,
    connectedInterfacePort: selectedLabelScale?.connectedInterfacePort || 0,
  });

  const isFormValid = data.macId.trim() !== '' && data.machineName.trim() !== '';

  const handleChange = (field) => (e) => {
    let value = e.target.value;
    if (e.target.type === 'number') {
      value = value === '' ? '' : Number(value);
    }
    
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSwitchChange = (field) => (e) => {
    setData((prev) => ({
      ...prev,
      [field]: e.target.checked,
    }));
  };

  const handleSubmit = () => {
    handleSuccess(data);
    handleClose();
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper} style={{ maxHeight: '90vh', overflowY: 'auto' }}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>
              {selectedLabelScale ? tCommon('Edit Label Scale') : tCommon('Add Label Scale')}
            </h2>
            <IconButton onClick={handleClose} size="small" className={styles.closeBtn}><CloseIcon /></IconButton>
          </div>

          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('MAC ID')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={data.macId}
                  onChange={handleChange('macId')}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Machine Name')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={data.machineName}
                  onChange={handleChange('machineName')}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Bill Prefix')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={data.billPrefix}
                  onChange={handleChange('billPrefix')}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Connected To')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={data.connectedTo}
                  onChange={handleChange('connectedTo')}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Connected Port')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  variant="outlined"
                  size="small"
                  type="number"
                  fullWidth
                  value={data.connectedPort}
                  onChange={handleChange('connectedPort')}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Machine Number')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  variant="outlined"
                  size="small"
                  type="number"
                  fullWidth
                  value={data.machineNumber}
                  onChange={handleChange('machineNumber')}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Connected Interface Port')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  variant="outlined"
                  size="small"
                  type="number"
                  fullWidth
                  value={data.connectedInterfacePort}
                  onChange={handleChange('connectedInterfacePort')}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Support Sales')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={data.isSupportSales}
                      onChange={handleSwitchChange('isSupportSales')}
                      color="primary"
                    />
                  }
                  label=""
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Support Unicode')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={data.isSupportUnicode}
                      onChange={handleSwitchChange('isSupportUnicode')}
                      color="primary"
                    />
                  }
                  label=""
                />
              </Grid>
            </Grid>

            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                onClick={handleSubmit}
                disabled={!isFormValid}
              >
                {selectedLabelScale ? tCommon('Update') : tCommon('Add')}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
